const actions = {
  // Criar/Listar
  listarTreinamentos: async (
    context,
    { unidadeId, treinamento, per_page, page }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`treinamento`, {
      params: {
        unidadeId,
        treinamento,
        per_page,
        page,
      },
    });

    return response;
  },

  criarTreinamento: async (
    context,
    { descricao, nome, unidadeId, validade }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.post(`treinamento`, {
      descricao,
      nome,
      unidadeId,
      validade,
    });

    return response;
  },

  // Status Treinamento

  listarStatusTreinamento: async (
    context,
    {
      per_page,
      presencaConfirmada,
      status,
      unidadeId,
      page,
      funcionario,
      download,
      treinamento,
      cargo,
      ghe,
      centroCusto,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`treinamento/funcionario/relatorio-status`, {
      params: {
        per_page,
        presencaConfirmada,
        status,
        unidadeId,
        page,
        funcionario,
        download,
        treinamento,
        cargo,
        ghe,
        centroCusto,
      },
    });

    return response;
  },
  //Lista Capacitações

  listarCapacitacoes: async (
    context,
    {
      descricao,
      per_page,
      status,
      unidadeId,
      page,
      data_criacao,
      data_execucao,
      pessoas,
      treinamento,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`capacitacao`, {
      params: {
        descricao,
        per_page,
        status,
        unidadeId,
        page,
        data_criacao,
        data_execucao,
        pessoas,
        treinamento,
      },
    });

    return response;
  },

  //Detalhar Capacitações

  detalharCapacitacao: async (context, { capacitacao_id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`capacitacao/${capacitacao_id}`);

    return response;
  },

  verificarAutorizacaoEdicao: async (context) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(
      `authorization/users/permissions/capacitacao-modificar-data-realizacao`
    );

    return response;
  },

  modificarData: async (context, { capacitacaoId, dataRealizacao }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(`capacitacao/modificar-data-realizacao`, {
      capacitacaoId,
      dataRealizacao,
    });

    return response;
  },

  confirmarPresenca: async (context, { capacitacaoId, id, presenca }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.post(`capacitacao/confirmar-presenca`, {
      capacitacaoId,
      funcionarios: [{ id, presenca }],
    });

    return response;
  },

  //Upload Arquivo

  uploadCapacitacao: async (context, { arquivo, unidadeId }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.post(`treinamento/carga-inicial`, {
      arquivo,
      unidadeId,
    });

    return response;
  },

  uploadAssociacaoMassa: async (context, { arquivo, unidadeId }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.post(`treinamento/carga-associar-grupo`, {
      arquivo,
      unidadeId,
    });

    return response;
  },

  uploadTreinamento: async (context, { arquivo, unidadeId }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.post(`treinamento/carga-treinamento`, {
      arquivo,
      unidadeId,
    });

    return response;
  },

  // Detalhar Treinamento
  detalharTreinamento: async (context, { treinamento_id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`treinamento/${treinamento_id}`);

    return response;
  },

  listarGruposProdutos: async (
    context,
    { per_page, vendor_id, page, search }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`product-groups`, {
      params: {
        per_page,
        vendor_id,
        page,
        search,
      },
    });

    return response;
  },

  desassociarGrupo: async (context, { treinamentoId, id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.post(`treinamento/desassociar-grupos`, {
      grupos: [id],
      treinamentoId,
    });

    return response;
  },

  associarGrupo: async (context, { treinamentoId, id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.post(`treinamento/associar-grupos`, {
      grupos: [id],
      treinamentoId,
    });

    return response;
  },

  listarUsuarios: async (context, { per_page, vendor_id, page, search }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`auth/users`, {
      params: {
        per_page,
        vendor_id,
        page,
        search,
      },
    });

    return response;
  },

  associarPessoa: async (context, { treinamentoId, id, obrigatorio }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.post(`treinamento/associar-funcionarios`, {
      funcionarios: [{ id, obrigatorio }],
      treinamentoId,
    });

    return response;
  },

  desassociarPessoa: async (context, { treinamentoId, id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.post(`treinamento/desassociar-funcionarios`, {
      funcionarios: [{ id }],
      treinamentoId,
    });

    return response;
  },

  // Agendamentos
  listarAgendamentos: async (
    context,
    {
      data_final,
      data_inicial,
      instrutor,
      treinamento,
      usuario,
      vendor_id,
      page,
      per_page,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`agendamento/cabecalhos`, {
      params: {
        data_final,
        data_inicial,
        instrutor,
        treinamento,
        usuario,
        vendor_id,
        page,
        per_page,
      },
    });

    return response;
  },

  criarNovoAgendamento: async (
    context,
    { data, hora, instrutor, local, uuid_treinamento }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.post(`agendamento`, {
      data,
      hora,
      instrutor,
      local,
      uuid_treinamento,
    });

    return response;
  },

  //Detalhe Agendamento

  detalharAgendamento: async (context, { data_final, uuid_agendamento }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`agendamento`, {
      params: {
        data_final,
        uuid_agendamento,
        data_inicial: "01/01/2000",
      },
    });

    return response;
  },

  criarCapacitacaoPorAgendamento: async (
    context,
    {
      unidadeId,
      agendamentoId,
      instrutorId,
      instrutorNome,
      descricao,
      funcionarios,
      reciclagem,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.post(`capacitacao/criar-por-agendamento`, {
      unidadeId,
      agendamentoId,
      instrutorId,
      instrutorNome,
      descricao,
      funcionarios,
      reciclagem,
    });

    return response;
  },

  //Criar Capacitação
  criarCapacitacao: async (
    context,
    { descricao, funcionarios, treinamentos, unidadeId }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.post(`capacitacao`, {
      descricao,
      funcionarios,
      treinamentos,
      unidadeId,
    });

    return response;
  },

  finalizarCapacitacao: async (context, { capacitacaoId, dataRealizacao }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.post(`capacitacao/finalizar`, {
      capacitacaoId,
      dataRealizacao,
    });

    return response;
  },

  criarCertificado: async (
    context,
    {
      nome_treinamento,
      nome_vendor,
      data_aplicacao_treinamento,
      nome_responsavel,
      identificacao_responsavel,
      cargo_responsavel,
      carga_horaria,
      conformidades,
      titulo_certificado,
      descricao_certificado,
      data_aplicacao_certificado,
      titulo_conteudo_programatico,
      subtitulo_conteudo_programatico,
      descricao_conteudo_programatico,
      treinamento_id,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.post(
      `treinamento/${treinamento_id}/certificado`,
      {
        nome_treinamento,
        nome_vendor,
        data_aplicacao_treinamento,
        nome_responsavel,
        identificacao_responsavel,
        cargo_responsavel,
        carga_horaria,
        conformidades,
        titulo_certificado,
        descricao_certificado,
        data_aplicacao_certificado,
        titulo_conteudo_programatico,
        subtitulo_conteudo_programatico,
        descricao_conteudo_programatico,
      }
    );

    return response;
  },

  detalharCertificado: async (context, { treinamento_id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`treinamento/${treinamento_id}/certificado`);

    return response;
  },

  gerarCertificadoFuncionario: async (
    context,
    { funcionario_id, treinamento_id, capacitacao_id }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`treinamento/certificado/funcionario`, {
      params: {
        funcionario_id,
        treinamento_id,
        capacitacao_id,
      },
    });

    return response;
  },

  coletarAssinaturaResponsavel: async (
    context,
    { treinamento_uuid, assinatura }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.post(
      `treinamento/${treinamento_uuid}/certificado/assinatura-responsavel`,
      { assinatura }
    );
    return response;
  },

  coletarAssinaturaInstrutor: async (
    context,
    { capacitacao_uuid, assinatura }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.post(
      `capacitacao/${capacitacao_uuid}/assinatura-instrutor`,
      { assinatura }
    );
    return response;
  },

  //Status Treinamento Consolidado
  dadosConsolidadosTreinamento: async (
    context,
    {
      unidadeId,
      funcionario,
      funcionarioGhe,
      funcionarioCargo,
      centroCusto,
      treinamento,
      validade,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`treinamento/status/consolidado`, {
      params: {
        unidadeId,
        funcionario,
        funcionarioGhe,
        funcionarioCargo,
        centroCusto,
        treinamento,
        validade,
      },
    });

    return response;
  },

  dadosConsolidadosFuncionario: async (
    context,
    {
      unidadeId,
      funcionario,
      funcionarioGhe,
      funcionarioCargo,
      centroCusto,
      treinamento,
      validade,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(
      `treinamento/status/consolidado/funcionario`,
      {
        params: {
          unidadeId,
          funcionario,
          funcionarioGhe,
          funcionarioCargo,
          centroCusto,
          treinamento,
          validade,
        },
      }
    );

    return response;
  },

  detalharCabecalhoTreinamento: async (context, { capacitacao_id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`treinamento/${capacitacao_id}/certificado`);

    return response;
  },
};

export const treinamento = {
  actions,
  namespaced: true,
};
